import DropdownIcon from "../../assets/images/DropDownIcon";


export const CustomDropdownIcon = () => {
    return (
      <div className="pr-3">
        <DropdownIcon />
      </div>
    );
  };